import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'components';

import './style.scss';

function AssignmentReturnFailedModal({
  isVisible = false,
  onOverlayClick = () => {},
  onClick = () => {},
  onClose = () => {},
}) {
  return (
    <Modal
      className="tv-assignment-return-failed-modal__container"
      hideHeader
      onClose={onClose}
      onOverlayClick={onOverlayClick}
      isVisible={isVisible}
    >
      <p>
        <b className="tv-assignment-return-failed-modal__title">
          Vi lyckades inte lämna tillbaka ditt uppdrag
        </b>
      </p>
      <p className="tv-assignment-return-failed-modal__description">
        Vi lyckades inte hitta en ersättare till ditt uppdrag. Vänligen kontakta
        oss.
      </p>

      <div className="tv-assignment-return-failed-modal__button-wrapper">
        <Button
          onClick={onClose}
          className="tv-assignment-return-failed-modal__button-wrapper__button"
          label="Kontakta transvoice"
          palette="outline"
        />
        <Button
          onClick={onClick}
          className="tv-assignment-return-failed-modal__button-wrapper__button"
          label="Försök igen"
        />
      </div>
    </Modal>
  );
}

AssignmentReturnFailedModal.propTypes = {
  isVisible: PropTypes.bool,
  onOverlayClick: PropTypes.func,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
};

export default AssignmentReturnFailedModal;
